/**
 * Permission System for eBotics Solutions
 * Handles permission checking with support for composite permissions
 */

// All available permissions grouped by category
export const PERMISSIONS = {
  // Global Permissions
  GLOBAL_ALL: 'GLOBAL_ALL',
  GLOBAL_VIEW_ALL: 'GLOBAL_VIEW_ALL',
  
  // Admin Portal
  ADMIN_PORTAL_ALL: 'ADMIN_PORTAL_ALL',
  ADMIN_PORTAL_DASHBOARD_VIEW: 'ADMIN_PORTAL_DASHBOARD_VIEW',
  ADMIN_PORTAL_VIEW_ALL: 'ADMIN_PORTAL_VIEW_ALL',
  
  // User Management
  USER_CREATE: 'USER_CREATE',
  USER_LIST: 'USER_LIST',
  USER_MANAGEMENT_ALL: 'USER_MANAGEMENT_ALL',
  USER_MANAGEMENT_VIEW_ALL: 'USER_MANAGEMENT_VIEW_ALL',
  USER_UPDATE: 'USER_UPDATE',
  USER_UPDATE_STATUS: 'USER_UPDATE_STATUS',
  
  // Role Management
  ROLE_CREATE: 'ROLE_CREATE',
  ROLE_LIST: 'ROLE_LIST',
  ROLE_MANAGEMENT_ALL: 'ROLE_MANAGEMENT_ALL',
  ROLE_MANAGEMENT_VIEW_ALL: 'ROLE_MANAGEMENT_VIEW_ALL',
  ROLE_UPDATE: 'ROLE_UPDATE',
  ROLE_UPDATE_PERMISSIONS: 'ROLE_UPDATE_PERMISSIONS',
  ROLE_UPDATE_STATUS: 'ROLE_UPDATE_STATUS',
  
  // Practice Management
  PRACTICE_CREATE: 'PRACTICE_CREATE',
  PRACTICE_DELETE: 'PRACTICE_DELETE',
  PRACTICE_GET: 'PRACTICE_GET',
  PRACTICE_LIST: 'PRACTICE_LIST',
  PRACTICE_LOCATION_CREATE: 'PRACTICE_LOCATION_CREATE',
  PRACTICE_LOCATION_DELETE: 'PRACTICE_LOCATION_DELETE',
  PRACTICE_LOCATION_GET: 'PRACTICE_LOCATION_GET',
  PRACTICE_LOCATION_LIST: 'PRACTICE_LOCATION_LIST',
  PRACTICE_LOCATION_STATUS_UPDATE: 'PRACTICE_LOCATION_STATUS_UPDATE',
  PRACTICE_LOCATION_UPDATE: 'PRACTICE_LOCATION_UPDATE',
  PRACTICE_MANAGEMENT_ALL: 'PRACTICE_MANAGEMENT_ALL',
  PRACTICE_MANAGEMENT_VIEW_ALL: 'PRACTICE_MANAGEMENT_VIEW_ALL',
  PRACTICE_UPDATE: 'PRACTICE_UPDATE',
  PRACTICE_UPDATE_STATUS: 'PRACTICE_UPDATE_STATUS',
  
  // Check Management
  BULK_IMPORT_DASHBOARD_VIEW: 'BULK_IMPORT_DASHBOARD_VIEW',
  BULK_IMPORT_JOB_CREATE: 'BULK_IMPORT_JOB_CREATE',
  BULK_IMPORT_JOB_DELETE: 'BULK_IMPORT_JOB_DELETE',
  BULK_IMPORT_JOB_GET: 'BULK_IMPORT_JOB_GET',
  BULK_IMPORT_JOB_PROMOTE: 'BULK_IMPORT_JOB_PROMOTE',
  BULK_IMPORT_JOB_REVALIDATE: 'BULK_IMPORT_JOB_REVALIDATE',
  BULK_IMPORT_JOB_UPDATE: 'BULK_IMPORT_JOB_UPDATE',
  BULK_IMPORT_STAGE_DELETE: 'BULK_IMPORT_STAGE_DELETE',
  BULK_IMPORT_STAGE_LIST: 'BULK_IMPORT_STAGE_LIST',
  BULK_IMPORT_STAGE_UPDATE: 'BULK_IMPORT_STAGE_UPDATE',
  CHECK_ACTIVITY_VIEW: 'CHECK_ACTIVITY_VIEW',
  CHECK_BATCH_CREATE: 'CHECK_BATCH_CREATE',
  CHECK_BATCH_DELETE: 'CHECK_BATCH_DELETE',
  CHECK_BATCH_UPDATE: 'CHECK_BATCH_UPDATE',
  CHECK_BULK_ASSIGNMENT: 'CHECK_BULK_ASSIGNMENT',
  CHECK_CLARIFICATION_COMMENT: 'CHECK_CLARIFICATION_COMMENT',
  CHECK_CLARIFICATION_CREATE: 'CHECK_CLARIFICATION_CREATE',
  CHECK_CLARIFICATION_DASHBOARD_VIEW: 'CHECK_CLARIFICATION_DASHBOARD_VIEW',
  CHECK_CLARIFICATION_DELETE: 'CHECK_CLARIFICATION_DELETE',
  CHECK_CLARIFICATION_LIST_BY_CHECK: 'CHECK_CLARIFICATION_LIST_BY_CHECK',
  CHECK_CLARIFICATION_UPDATE: 'CHECK_CLARIFICATION_UPDATE',
  CHECK_CREATE: 'CHECK_CREATE',
  CHECK_DASHBOARD_VIEW: 'CHECK_DASHBOARD_VIEW',
  CHECK_DELETE: 'CHECK_DELETE',
  CHECK_GET: 'CHECK_GET',
  CHECK_MANAGEMENT_ALL: 'CHECK_MANAGEMENT_ALL',
  CHECK_MANAGEMENT_VIEW_ALL: 'CHECK_MANAGEMENT_VIEW_ALL',
  CHECK_UPDATE: 'CHECK_UPDATE',
  
  // DIT/DRL Management
  DIT_DRL_ACTIVITY_VIEW: 'DIT_DRL_ACTIVITY_VIEW',
  DIT_DRL_BATCH_CREATE: 'DIT_DRL_BATCH_CREATE',
  DIT_DRL_BATCH_DELETE: 'DIT_DRL_BATCH_DELETE',
  DIT_DRL_BATCH_UPDATE: 'DIT_DRL_BATCH_UPDATE',
  DIT_DRL_CLARIFICATION_COMMENT: 'DIT_DRL_CLARIFICATION_COMMENT',
  DIT_DRL_CLARIFICATION_CREATE: 'DIT_DRL_CLARIFICATION_CREATE',
  DIT_DRL_CLARIFICATION_DASHBOARD_VIEW: 'DIT_DRL_CLARIFICATION_DASHBOARD_VIEW',
  DIT_DRL_CLARIFICATION_DELETE: 'DIT_DRL_CLARIFICATION_DELETE',
  DIT_DRL_CLARIFICATION_LIST_BY_DIT_DRL: 'DIT_DRL_CLARIFICATION_LIST_BY_DIT_DRL',
  DIT_DRL_CLARIFICATION_UPDATE: 'DIT_DRL_CLARIFICATION_UPDATE',
  DIT_DRL_CREATE: 'DIT_DRL_CREATE',
  DIT_DRL_DASHBOARD_VIEW: 'DIT_DRL_DASHBOARD_VIEW',
  DIT_DRL_DELETE: 'DIT_DRL_DELETE',
  DIT_DRL_GET: 'DIT_DRL_GET',
  DIT_DRL_MANAGEMENT_ALL: 'DIT_DRL_MANAGEMENT_ALL',
  DIT_DRL_MANAGEMENT_VIEW_ALL: 'DIT_DRL_MANAGEMENT_VIEW_ALL',
  DIT_DRL_SITE_CREATE: 'DIT_DRL_SITE_CREATE',
  DIT_DRL_SITE_DELETE: 'DIT_DRL_SITE_DELETE',
  DIT_DRL_SITE_GET: 'DIT_DRL_SITE_GET',
  DIT_DRL_SITE_LIST: 'DIT_DRL_SITE_LIST',
  DIT_DRL_SITE_STATUS_UPDATE: 'DIT_DRL_SITE_STATUS_UPDATE',
  DIT_DRL_SITE_UPDATE: 'DIT_DRL_SITE_UPDATE',
  DIT_DRL_UPDATE: 'DIT_DRL_UPDATE',

  // Clarification Validation
  CLARIFICATION_VALIDATION_ALL: 'CLARIFICATION_VALIDATION_ALL',
  CLARIFICATION_VALIDATION_CREATE: 'CLARIFICATION_VALIDATION_CREATE',
  CLARIFICATION_VALIDATION_DELETE: 'CLARIFICATION_VALIDATION_DELETE',
  CLARIFICATION_VALIDATION_REPORT_EXPORT: 'CLARIFICATION_VALIDATION_REPORT_EXPORT',
  CLARIFICATION_VALIDATION_UPDATE: 'CLARIFICATION_VALIDATION_UPDATE',
  CLARIFICATION_VALIDATION_VIEW: 'CLARIFICATION_VALIDATION_VIEW',
  CLARIFICATION_VALIDATION_VIEW_ALL: 'CLARIFICATION_VALIDATION_VIEW_ALL',
};

// Permission groups mapping for composite permissions
const PERMISSION_GROUPS = {
  GLOBAL_ALL: ['*'], // All permissions
  GLOBAL_VIEW_ALL: [
    // All view permissions across all groups
    'ADMIN_PORTAL_DASHBOARD_VIEW',
    'USER_LIST',
    'ROLE_LIST',
    'PRACTICE_LIST',
    'PRACTICE_GET',
    'PRACTICE_LOCATION_LIST',
    'PRACTICE_LOCATION_GET',
    'CHECK_DASHBOARD_VIEW',
    'CHECK_GET',
    'CHECK_CLARIFICATION_DASHBOARD_VIEW',
    'BULK_IMPORT_DASHBOARD_VIEW',
    'DIT_DRL_DASHBOARD_VIEW',
    'DIT_DRL_GET',
    'DIT_DRL_CLARIFICATION_DASHBOARD_VIEW',
  ],
  
  ADMIN_PORTAL_ALL: [
    'ADMIN_PORTAL_DASHBOARD_VIEW',
    'USER_CREATE',
    'USER_LIST',
    'USER_UPDATE',
    'USER_UPDATE_STATUS',
    'ROLE_CREATE',
    'ROLE_LIST',
    'ROLE_UPDATE',
    'ROLE_UPDATE_STATUS',
    'ROLE_UPDATE_PERMISSIONS',
    'PRACTICE_LIST',
    'PRACTICE_GET',
  ],
  ADMIN_PORTAL_VIEW_ALL: [
    'ADMIN_PORTAL_DASHBOARD_VIEW',
    'USER_LIST',
    'ROLE_LIST',
    'PRACTICE_LIST',
  ],
  
  USER_MANAGEMENT_ALL: [
    'USER_CREATE',
    'USER_LIST',
    'USER_UPDATE',
    'USER_UPDATE_STATUS',
  ],
  USER_MANAGEMENT_VIEW_ALL: [
    'USER_LIST',
  ],
  
  ROLE_MANAGEMENT_ALL: [
    'ROLE_CREATE',
    'ROLE_LIST',
    'ROLE_UPDATE',
    'ROLE_UPDATE_PERMISSIONS',
    'ROLE_UPDATE_STATUS',
  ],
  ROLE_MANAGEMENT_VIEW_ALL: [
    'ROLE_LIST',
  ],
  
  PRACTICE_MANAGEMENT_ALL: [
    'PRACTICE_CREATE',
    'PRACTICE_LIST',
    'PRACTICE_GET',
    'PRACTICE_UPDATE',
    'PRACTICE_UPDATE_STATUS',
    'PRACTICE_DELETE',
    'PRACTICE_LOCATION_CREATE',
    'PRACTICE_LOCATION_LIST',
    'PRACTICE_LOCATION_GET',
    'PRACTICE_LOCATION_UPDATE',
    'PRACTICE_LOCATION_STATUS_UPDATE',
    'PRACTICE_LOCATION_DELETE',
  ],
  PRACTICE_MANAGEMENT_VIEW_ALL: [
    'PRACTICE_LIST',
    'PRACTICE_GET',
    'PRACTICE_LOCATION_LIST',
    'PRACTICE_LOCATION_GET',
  ],
  
  CHECK_MANAGEMENT_ALL: [
    'BULK_IMPORT_DASHBOARD_VIEW',
    'BULK_IMPORT_JOB_CREATE',
    'BULK_IMPORT_JOB_DELETE',
    'BULK_IMPORT_JOB_GET',
    'BULK_IMPORT_JOB_PROMOTE',
    'BULK_IMPORT_JOB_REVALIDATE',
    'BULK_IMPORT_JOB_UPDATE',
    'BULK_IMPORT_STAGE_DELETE',
    'BULK_IMPORT_STAGE_LIST',
    'BULK_IMPORT_STAGE_UPDATE',
    'CHECK_ACTIVITY_VIEW',
    'CHECK_BATCH_CREATE',
    'CHECK_BATCH_DELETE',
    'CHECK_BATCH_UPDATE',
    'CHECK_BULK_ASSIGNMENT',
    'CHECK_CLARIFICATION_COMMENT',
    'CHECK_CLARIFICATION_CREATE',
    'CHECK_CLARIFICATION_DASHBOARD_VIEW',
    'CHECK_CLARIFICATION_DELETE',
    'CHECK_CLARIFICATION_LIST_BY_CHECK',
    'CHECK_CLARIFICATION_UPDATE',
    'CHECK_CREATE',
    'CHECK_DASHBOARD_VIEW',
    'CHECK_DELETE',
    'CHECK_GET',
    'CHECK_UPDATE',
  ],
  CHECK_MANAGEMENT_VIEW_ALL: [
    'CHECK_DASHBOARD_VIEW',
    'CHECK_GET',
    'CHECK_CLARIFICATION_DASHBOARD_VIEW',
    'CHECK_CLARIFICATION_LIST_BY_CHECK',
    'CHECK_ACTIVITY_VIEW',
    'BULK_IMPORT_DASHBOARD_VIEW',
    'BULK_IMPORT_JOB_GET',
    'BULK_IMPORT_STAGE_LIST',
  ],
  
  DIT_DRL_MANAGEMENT_ALL: [
    'DIT_DRL_ACTIVITY_VIEW',
    'DIT_DRL_BATCH_CREATE',
    'DIT_DRL_BATCH_DELETE',
    'DIT_DRL_BATCH_UPDATE',
    'DIT_DRL_CLARIFICATION_COMMENT',
    'DIT_DRL_CLARIFICATION_CREATE',
    'DIT_DRL_CLARIFICATION_DASHBOARD_VIEW',
    'DIT_DRL_CLARIFICATION_DELETE',
    'DIT_DRL_CLARIFICATION_LIST_BY_DIT_DRL',
    'DIT_DRL_CLARIFICATION_UPDATE',
    'DIT_DRL_CREATE',
    'DIT_DRL_DASHBOARD_VIEW',
    'DIT_DRL_DELETE',
    'DIT_DRL_GET',
    'DIT_DRL_SITE_CREATE',
    'DIT_DRL_SITE_DELETE',
    'DIT_DRL_SITE_GET',
    'DIT_DRL_SITE_LIST',
    'DIT_DRL_SITE_STATUS_UPDATE',
    'DIT_DRL_SITE_UPDATE',
    'DIT_DRL_UPDATE',
  ],
  DIT_DRL_MANAGEMENT_VIEW_ALL: [
    'DIT_DRL_DASHBOARD_VIEW',
    'DIT_DRL_GET',
    'DIT_DRL_CLARIFICATION_DASHBOARD_VIEW',
    'DIT_DRL_CLARIFICATION_LIST_BY_DIT_DRL',
    'DIT_DRL_ACTIVITY_VIEW',
    'DIT_DRL_SITE_LIST',
    'DIT_DRL_SITE_GET',
  ],

  CLARIFICATION_VALIDATION_ALL: [
    'CLARIFICATION_VALIDATION_CREATE',
    'CLARIFICATION_VALIDATION_DELETE',
    'CLARIFICATION_VALIDATION_REPORT_EXPORT',
    'CLARIFICATION_VALIDATION_UPDATE',
    'CLARIFICATION_VALIDATION_VIEW',
  ],
  CLARIFICATION_VALIDATION_VIEW_ALL: [
    'CLARIFICATION_VALIDATION_VIEW',
  ],
};

/**
 * Check if user has a specific permission
 * Handles composite permissions automatically
 * @param {Array<string>} userPermissions - Array of permission codes the user has
 * @param {string|Array<string>} requiredPermission - Permission code(s) to check
 * @returns {boolean} - True if user has the permission
 */
export const hasPermission = (userPermissions = [], requiredPermission) => {
  if (!userPermissions || userPermissions.length === 0) {
    return false;
  }

  // Handle GLOBAL_ALL - grants all permissions
  if (userPermissions.includes(PERMISSIONS.GLOBAL_ALL)) {
    return true;
  }

  // Handle array of required permissions (check if user has ANY of them)
  if (Array.isArray(requiredPermission)) {
    return requiredPermission.some(perm => hasPermission(userPermissions, perm));
  }

  // Direct permission check
  if (userPermissions.includes(requiredPermission)) {
    return true;
  }

  // Check composite permissions
  for (const userPerm of userPermissions) {
    const groupPermissions = PERMISSION_GROUPS[userPerm];
    
    if (groupPermissions) {
      // If group contains '*', user has all permissions
      if (groupPermissions.includes('*')) {
        return true;
      }
      
      // Check if the required permission is in this group
      if (groupPermissions.includes(requiredPermission)) {
        return true;
      }
      
      // Recursively check nested composite permissions
      if (hasPermission(groupPermissions, requiredPermission)) {
        return true;
      }
    }
  }

  return false;
};

/**
 * Check if user has all of the specified permissions
 * @param {Array<string>} userPermissions - Array of permission codes the user has
 * @param {Array<string>} requiredPermissions - Array of permission codes required
 * @returns {boolean} - True if user has all permissions
 */
export const hasAllPermissions = (userPermissions = [], requiredPermissions = []) => {
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }
  
  return requiredPermissions.every(perm => hasPermission(userPermissions, perm));
};

/**
 * Check if user has any of the specified permissions
 * @param {Array<string>} userPermissions - Array of permission codes the user has
 * @param {Array<string>} requiredPermissions - Array of permission codes (user needs at least one)
 * @returns {boolean} - True if user has at least one permission
 */
export const hasAnyPermission = (userPermissions = [], requiredPermissions = []) => {
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }
  
  return requiredPermissions.some(perm => hasPermission(userPermissions, perm));
};

/**
 * Get permission display name
 * @param {string} permissionCode - Permission code
 * @returns {string} - Human-readable permission name
 */
export const getPermissionDisplayName = (permissionCode) => {
  const permissionMap = {
    [PERMISSIONS.ADMIN_PORTAL_DASHBOARD_VIEW]: 'View Admin Dashboard',
    [PERMISSIONS.USER_CREATE]: 'Create User',
    [PERMISSIONS.USER_LIST]: 'List Users',
    [PERMISSIONS.USER_UPDATE]: 'Update User',
    [PERMISSIONS.USER_UPDATE_STATUS]: 'Activate/Deactivate User',
    [PERMISSIONS.ROLE_CREATE]: 'Create Role',
    [PERMISSIONS.ROLE_LIST]: 'List Roles',
    [PERMISSIONS.ROLE_UPDATE]: 'Update Role',
    [PERMISSIONS.ROLE_UPDATE_PERMISSIONS]: 'Update Role Permissions',
    [PERMISSIONS.ROLE_UPDATE_STATUS]: 'Activate/Deactivate Role',
    [PERMISSIONS.PRACTICE_CREATE]: 'Create Practice',
    [PERMISSIONS.PRACTICE_LIST]: 'List Practices',
    [PERMISSIONS.PRACTICE_GET]: 'View Practice',
    [PERMISSIONS.PRACTICE_UPDATE]: 'Update Practice',
    [PERMISSIONS.PRACTICE_UPDATE_STATUS]: 'Activate/Deactivate Practice',
    [PERMISSIONS.PRACTICE_DELETE]: 'Delete Practice',
    [PERMISSIONS.PRACTICE_LOCATION_CREATE]: 'Create Location',
    [PERMISSIONS.PRACTICE_LOCATION_LIST]: 'List Locations',
    [PERMISSIONS.PRACTICE_LOCATION_GET]: 'View Location',
    [PERMISSIONS.PRACTICE_LOCATION_UPDATE]: 'Update Location',
    [PERMISSIONS.PRACTICE_LOCATION_STATUS_UPDATE]: 'Activate/Deactivate Location',
    [PERMISSIONS.PRACTICE_LOCATION_DELETE]: 'Delete Location',
    [PERMISSIONS.BULK_IMPORT_DASHBOARD_VIEW]: 'View Bulk Import Dashboard',
    [PERMISSIONS.BULK_IMPORT_JOB_CREATE]: 'Create Bulk Import Job',
    [PERMISSIONS.BULK_IMPORT_JOB_DELETE]: 'Delete Bulk Import Job',
    [PERMISSIONS.BULK_IMPORT_JOB_GET]: 'View Bulk Import Job',
    [PERMISSIONS.BULK_IMPORT_JOB_PROMOTE]: 'Promote Bulk Import Job',
    [PERMISSIONS.BULK_IMPORT_JOB_REVALIDATE]: 'Re-validate Bulk Import Job',
    [PERMISSIONS.BULK_IMPORT_JOB_UPDATE]: 'Update Bulk Import Job',
    [PERMISSIONS.BULK_IMPORT_STAGE_DELETE]: 'Delete Staged Check',
    [PERMISSIONS.BULK_IMPORT_STAGE_LIST]: 'List Staged Checks',
    [PERMISSIONS.BULK_IMPORT_STAGE_UPDATE]: 'Update Staged Check',
    [PERMISSIONS.CHECK_ACTIVITY_VIEW]: 'View Check Activities',
    [PERMISSIONS.CHECK_BATCH_CREATE]: 'Create Check Batch',
    [PERMISSIONS.CHECK_BATCH_DELETE]: 'Delete Check Batch',
    [PERMISSIONS.CHECK_BATCH_UPDATE]: 'Update Check Batch',
    [PERMISSIONS.CHECK_BULK_ASSIGNMENT]: 'Bulk Assign Checks',
    [PERMISSIONS.CHECK_CLARIFICATION_COMMENT]: 'Comment on Clarification',
    [PERMISSIONS.CHECK_CLARIFICATION_CREATE]: 'Create Clarification',
    [PERMISSIONS.CHECK_CLARIFICATION_DASHBOARD_VIEW]: 'View Clarifications Dashboard',
    [PERMISSIONS.CHECK_CLARIFICATION_DELETE]: 'Delete Clarification',
    [PERMISSIONS.CHECK_CLARIFICATION_LIST_BY_CHECK]: 'List Check Clarifications',
    [PERMISSIONS.CHECK_CLARIFICATION_UPDATE]: 'Update Clarification',
    [PERMISSIONS.CHECK_CREATE]: 'Create Check',
    [PERMISSIONS.CHECK_DASHBOARD_VIEW]: 'View Checks Dashboard',
    [PERMISSIONS.CHECK_DELETE]: 'Delete Check',
    [PERMISSIONS.CHECK_GET]: 'View Check Details',
    [PERMISSIONS.CHECK_UPDATE]: 'Update Check',
    [PERMISSIONS.DIT_DRL_ACTIVITY_VIEW]: 'View DIT/DRL Activities',
    [PERMISSIONS.DIT_DRL_BATCH_CREATE]: 'Create DIT/DRL Batch',
    [PERMISSIONS.DIT_DRL_BATCH_DELETE]: 'Delete DIT/DRL Batch',
    [PERMISSIONS.DIT_DRL_BATCH_UPDATE]: 'Update DIT/DRL Batch',
    [PERMISSIONS.DIT_DRL_CLARIFICATION_COMMENT]: 'Comment on DIT/DRL Clarification',
    [PERMISSIONS.DIT_DRL_CLARIFICATION_CREATE]: 'Create DIT/DRL Clarification',
    [PERMISSIONS.DIT_DRL_CLARIFICATION_DASHBOARD_VIEW]: 'View DIT/DRL Clarifications Dashboard',
    [PERMISSIONS.DIT_DRL_CLARIFICATION_DELETE]: 'Delete DIT/DRL Clarification',
    [PERMISSIONS.DIT_DRL_CLARIFICATION_LIST_BY_DIT_DRL]: 'List DIT/DRL Clarifications',
    [PERMISSIONS.DIT_DRL_CLARIFICATION_UPDATE]: 'Update DIT/DRL Clarification',
    [PERMISSIONS.DIT_DRL_CREATE]: 'Create DIT/DRL',
    [PERMISSIONS.DIT_DRL_DASHBOARD_VIEW]: 'View DIT/DRL Dashboard',
    [PERMISSIONS.DIT_DRL_DELETE]: 'Delete DIT/DRL',
    [PERMISSIONS.DIT_DRL_GET]: 'View DIT/DRL Details',
    [PERMISSIONS.DIT_DRL_SITE_CREATE]: 'Create DIT/DRL Site',
    [PERMISSIONS.DIT_DRL_SITE_DELETE]: 'Delete DIT/DRL Site',
    [PERMISSIONS.DIT_DRL_SITE_GET]: 'View DIT/DRL Site',
    [PERMISSIONS.DIT_DRL_SITE_LIST]: 'List DIT/DRL Sites',
    [PERMISSIONS.DIT_DRL_SITE_STATUS_UPDATE]: 'Activate/Deactivate DIT/DRL Site',
    [PERMISSIONS.DIT_DRL_SITE_UPDATE]: 'Update DIT/DRL Site',
    [PERMISSIONS.DIT_DRL_UPDATE]: 'Update DIT/DRL',
    [PERMISSIONS.CLARIFICATION_VALIDATION_ALL]: 'All Clarification Validation permissions',
    [PERMISSIONS.CLARIFICATION_VALIDATION_CREATE]: 'Create clarification validation job (upload)',
    [PERMISSIONS.CLARIFICATION_VALIDATION_DELETE]: 'Delete clarification validation jobs',
    [PERMISSIONS.CLARIFICATION_VALIDATION_REPORT_EXPORT]: 'Export clarification validation report (XLSX)',
    [PERMISSIONS.CLARIFICATION_VALIDATION_UPDATE]: 'Update clarification validation staged rows / revalidate jobs',
    [PERMISSIONS.CLARIFICATION_VALIDATION_VIEW]: 'View clarification validation dashboard/jobs',
    [PERMISSIONS.CLARIFICATION_VALIDATION_VIEW_ALL]: 'All Clarification Validation view permissions',
  };
  
  return permissionMap[permissionCode] || permissionCode;
};

